// extracted by mini-css-extract-plugin
module.exports = {"list":"TodoList_list__1iuwu","list-count":"TodoList_list-count__y7UIn","placeholder":"TodoList_placeholder__3vkW8"};